<template>
  <div class="h-100">
    <div v-if="isLoaded">
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-between">
            <h1>{{ traineeFullName }}</h1>
            <div>
              <button
                class="btn btn-primary btn-icon ml-4"
                @click.stop.prevent="showRegistrationModal"
                :disabled="clientType == 5"
              >
                <span class="icon icon-plus" />
                {{ $tc('registerToSession', 1) }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="box-block box-block_secondary">
        <div class="row">
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">ID</div>
            <div class="font-weight-bold">{{ traineeId }}</div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.function') }}</div>
            <div class="font-weight-bold">{{ traineeFunction || '--' }}</div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('establishment') }}</div>
            <div>
              <span class="font-weight-bold">{{
                traineeEstablishment || '--'
              }}</span>
              <span
                class="icon icon-pen_primary ml-1 cursor-pointer"
                @click.prevent.stop="showEditModal()"
              ></span>
            </div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.email') }}</div>
            <div class="font-weight-bold">{{ traineeEmail || '--' }}</div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('LMSUsername') }}</div>
            <div class="font-weight-bold">{{ traineeLogin || '--' }}</div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.password') }}</div>
            <div class="font-weight-bold">{{ traineePassword || '--' }}</div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">TS id</div>
            <div class="font-weight-bold">{{ traineeIdTS || '--' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h3 class="mb-4">Additional fields</h3>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.preferred_language') }}</div>
            <div class="font-weight-bold">{{ preferredLanguage || '--' }}</div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.pay_code') }}</div>
            <div class="font-weight-bold">{{ payCode || '--' }}</div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.entry_date') }}</div>
            <div class="font-weight-bold">
              {{ formatDate(entryDate, 'DD.MM.YYYY') }}
            </div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.release_date') }}</div>
            <div class="font-weight-bold">
              {{ formatDate(releaseDate, 'DD.MM.YYYY') }}
            </div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.training_manager_email') }}</div>
            <div class="font-weight-bold">
              {{ trainingManagerEmail || '--' }}
            </div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.manager_email') }}</div>
            <div class="font-weight-bold">{{ managerEmail || '--' }}</div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.manager_firstname') }}</div>
            <div class="font-weight-bold">{{ managerFirstname || '--' }}</div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <div class="h5 mb-0">{{ $t('form.manager_lastname') }} :</div>
            <div class="font-weight-bold">{{ managerLastname || '--' }}</div>
          </div>
        </div>

        <div class="text-right">
          <button
            @click.stop.prevent="syncPassword"
            class="btn btn-icon btn-primary"
          >
            <span class="icon icon-sync"></span>
            {{ $t('syncTrainee') }}
          </button>
        </div>
      </div>

      <div class="row mt-5" v-if="futureRegistrations.length">
        <div class="col-12">
          <h2 class="mb-3">{{ $t('futureRegistrations') }}</h2>
          <div
            class="training"
            v-for="(futureRegistration, index) in futureRegistrations"
            :key="index"
          >
            <div class="training__main">
              <div>
                <div class="row d-flex align-items-end mb-4">
                  <div class="text-muted text-small text-uppercase mr-3">
                    {{ futureRegistration.courseName }}
                  </div>
                  <div
                    class="badge badge-icon badge-pill"
                    :class="
                      futureRegistration.courseTypeSlug == 'e-learning' ||
                      futureRegistration.courseTypeSlug == 'virtual-class'
                        ? 'badge-info badge-icon_pc '
                        : futureRegistration.courseTypeSlug == 'classroom'
                        ? 'badge-info badge-icon_school'
                        : 'badge-icon_combined badge-warning '
                    "
                  >
                    {{ futureRegistration.courseType }}
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-12"></div>
                </div>
                <div class="row mb-4">
                  <div class="col-12">
                    <div class="d-flex align-items-center">
                      <span class="mr-1 icon icon-calendar" />
                      <span class="small">
                        {{
                          formatDate(
                            futureRegistration.sessionStartAt,
                            'DD.MM.YYYY'
                          )
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="training__actions">
                <div class="iata" v-if="false">
                  <div class="iata__box"></div>
                </div>
                <!--                <a :href="futureRegistration.certificate" class="btn btn-primary mb-3"-->
                <!--                   target="_blanck">{{ $t( 'buttons.certificateButton' ) }}</a>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-if="passedRegistrations.length">
        <div class="col-12">
          <h2 class="mb-3">{{ $t('passedRegistrations') }}</h2>
          <div
            v-for="(passedRegistration, index) in passedRegistrations"
            :key="index"
          >
            <div class="training">
              <div class="training__main">
                <div>
                  <div class="row d-flex align-items-end mb-4">
                    <div class="text-muted text-small text-uppercase mr-3">
                      {{ passedRegistration.courseName }}
                    </div>
                    <div
                      class="badge badge-icon badge-pill"
                      :class="
                        passedRegistration.courseTypeSlug == 'e-learning' ||
                        passedRegistration.courseTypeSlug == 'virtual-class'
                          ? 'badge-info badge-icon_pc '
                          : passedRegistration.courseTypeSlug == 'classroom'
                          ? 'badge-info badge-icon_school'
                          : 'badge-icon_combined badge-warning '
                      "
                    >
                      {{ passedRegistration.courseType }}
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-12">
                      <div class="d-flex align-items-center">
                        <span class="ml-1 small">CERT : </span>
                        <span class="small">
                          {{ passedRegistration.certificateNumber }}
                        </span>
                      </div>
                      <div class="d-flex align-items-center">
                        <span class="ml-1 small">{{ $t('validity') }} : </span>
                        <span class="mr-1 icon icon-calendar" />
                        <span class="small">
                          {{
                            formatDate(
                              passedRegistration.resultIssueDate,
                              'DD.MM.YYYY'
                            )
                          }}
                        </span>
                      </div>
                      <div class="d-flex align-items-center">
                        <span class="ml-1 small">{{ $t('form.dlv') }} : </span>
                        <span class="mr-1 icon icon-calendar" />
                        <span class="small">
                          {{ formatDate(passedRegistration.dlv, 'DD.MM.YYYY') }}
                        </span>
                      </div>
                      <!-- <div class="d-flex align-items-center">
                        <span class="ml-1 small">{{$t("RegistrationDate") }} :</span>
                        <span class="mr-1 icon icon-calendar"/>
                        <span class="small">
                     {{ formatDate( passedRegistration.registrationCreatedAt, 'DD.MM.YYYY' ) }}
                    </span>
                      </div>-->
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-12">
                      <!--<div class="d-flex align-items-center">
                        <span class="mr-1 icon icon-calendar"/>
                        <span class="small">
                     {{ formatDate( passedRegistration.sessionStartAt, 'DD.MM.YYYY' ) }}
                    </span>
                      </div>-->
                    </div>
                  </div>
                </div>
                <div class="training__actions">
                  <div class="iata" v-if="false">
                    <div class="iata__box"></div>
                  </div>
                  <a
                    :href="passedRegistration.certificate"
                    class="btn btn-primary mb-3"
                    :class="{ disabled: !passedRegistration.certificate }"
                    target="_blanck"
                    :disabled="!passedRegistration.certificate"
                    >{{ $t('buttons.certificateButton') }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      class="h-100 row d-flex justify-content-center align-items-center"
    >
      <div class="col-12">
        <div class="d-flex justify-content-center align-items-center">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      </div>
    </div>

    <registration-trainee-modal></registration-trainee-modal>
    <establishment-modal></establishment-modal>
  </div>
</template>

<script>
import RegistrationTraineeModal from '@/js/components/Profile/my-team/modals/RegistrationTraineeModal.vue'
import { mapFields } from 'vuex-map-fields'
import EstablishmentModal from './modals/EstablishmentModal'

export default {
  name: 'TraineeInfo',
  components: { RegistrationTraineeModal, EstablishmentModal },
  data() {
    return {
      trainee: {},
      isLoaded: false,
    }
  },
  computed: {
    ...mapFields(['user']),
    ...mapFields(['trainees.trainees']),
    clientType() {
      return this.$lodash.get(this.user, 'clientType', false)
    },
    traineeFullName() {
      return this.trainee.lastname + ' ' + this.trainee.firstname
    },
    traineeId() {
      return this.$lodash.get(this.trainee, 'id', '--')
    },
    traineeFunction() {
      return this.$lodash.get(this.trainee, 'function', '--')
    },
    courseType() {
      return function (register) {
        if (this.$lodash.get(register, 'courseType', false)) {
          return register.courseType
        } else return ''
      }
    },
    sessionName() {
      return function (register) {
        if (this.$lodash.get(register, 'sessionName', false)) {
          return register.sessionName
        } else return '--'
      }
    },

    traineeEstablishment() {
      return this.$lodash.get(this.trainee, 'establishmentTitle', '--')
    },
    traineeEmail() {
      return this.$lodash.get(this.trainee, 'email', '--')
    },
    traineePassword() {
      return this.$lodash.get(this.trainee, 'password', '--')
    },
    traineeLogin() {
      return this.$lodash.get(this.trainee, 'login', '--')
    },
    traineeIdTS() {
      return this.$lodash.get(this.trainee, 'idTS', '--')
    },
    futureRegistrations() {
      return this.$lodash.get(this.trainee, 'futureRegistrations.data', [])
    },
    passedRegistrations() {
      return this.$lodash
        .get(this.trainee, 'passedRegistrations.data', [])
        .filter((r) => r.resultLessonStatus === 3)
    },
    preferredLanguage() {
      return this.$lodash.get(this.trainee, 'preferredLanguage', null)
    },
    payCode() {
      return this.$lodash.get(this.trainee, 'payCode', null)
    },
    entryDate() {
      return this.$lodash.get(this.trainee, 'entry_date', null)
    },
    releaseDate() {
      return this.$lodash.get(this.trainee, 'release_date', null)
    },
    trainingManagerEmail() {
      return this.$lodash.get(this.trainee, 'training_manager_email', null)
    },
    managerEmail() {
      return this.$lodash.get(this.trainee, 'manager_email', null)
    },
    managerFirstname() {
      return this.$lodash.get(this.trainee, 'manager_firstname', null)
    },
    managerLastname() {
      return this.$lodash.get(this.trainee, 'manager_lastname', null)
    },
  },
  mounted() {
    if (this.$lodash.has(this.$route.params, 'id')) {
      const traineeId = this.$route.params.id
      // this.trainee = this.$lodash.find(this.trainees, (trainee) => {
      //   return trainee.id == traineeId;
      // });
      this.getTraineeById(traineeId)
    }
    this.$bus.$on('trainee-establishment-update', () => {
      if (this.$lodash.has(this.$route.params, 'id')) {
        const traineeId = this.$route.params.id
        this.getTraineeById(traineeId)
      }
    })
  },
  methods: {
    showEditModal() {
      this.$bus.$emit('trainee-establishment-modal.show', this.trainee)
    },
    syncPassword() {
      this.isLoaded = false
      const data = {
        traineeId: this.traineeId,
      }
      this.$store.dispatch('syncTraineePasswords', data).then((response) => {
        this.trainee.password = response.password
        this.trainee.login = response.login
        if (!this.trainee) {
          this.getTraineeById(this.traineeId)
        } else {
          this.isLoaded = true
        }
      })
    },
    getTraineeById(traineeId) {
      this.isLoaded = false
      let data = {
        traineeId,
        params: { includes: 'results,passedRegistrations,futureRegistrations' },
      }
      this.$store.dispatch('trainees/getTraineeById', data).then((response) => {
        this.trainee = response
        if (!this.trainee) {
          this.$router.push({ name: 'MyTeam' }).catch((err) => {})
        }
        this.isLoaded = true
      })
    },
    showRegistrationModal() {
      let data = {}
      data.isAllSelected = false
      data.trainees = [this.trainee.id]
      data.total = 1
      this.$bus.$emit('trainee-registration-modal.show', data)
    },
    formatDate(date, format = 'YYYY.MM.DD') {
      if (date && this.$moment(date).isValid()) {
        return this.$moment(date).format(format)
      } else return '--'
    },
  },
}
</script>

<style scoped>
.box-block_secondary {
  background-color: #fff7e1;
}
</style>
